import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { images } from "../data/content";
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  const reduce = useReducedMotion();
  const fade = (delay: number) => ({
    initial: reduce ? false : {
      opacity: 0,
      y: 16
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.3,
      delay,
      ease
    }
  });
  return <section id="top" className="relative flex min-h-[100svh] items-end overflow-hidden bg-ink" data-id="element-110" data-mp="128phrcgdev41">
      <img src={images.hero} alt="Chat Bengal adulte à la robe brown rosetted, allongé sur une pierre sombre" className="absolute inset-0 h-full w-full object-cover object-[70%_center]" data-id="element-111" data-mp="xb5rtfab8tw9" />
      <div className="absolute inset-0 bg-ink/40 md:bg-transparent" aria-hidden="true" data-id="element-112" data-mp="nekmesudpgrw" />
      <div className="absolute inset-x-0 bottom-0 h-1/3 bg-ink/60 md:hidden" aria-hidden="true" data-id="element-113" data-mp="3czfk1vt6u14g" />

      <div className="relative mx-auto w-full max-w-7xl px-6 pb-16 pt-32 lg:px-10 lg:pb-24" data-id="element-114" data-mp="384jsewrv5frv">
        <div className="max-w-2xl" data-id="element-115" data-mp="3j9alrqbghebh">
          <motion.p {...fade(0.05)} className="mb-6 text-sm text-sage" data-id="element-116" data-mp="3o7c05xxxspgm">
            Élevage familial en Ardèche · Inscrit au LOOF
          </motion.p>
          <motion.h1 {...fade(0.12)} className="font-display text-[3.25rem] font-medium leading-[0.95] text-cream sm:text-7xl lg:text-[6.5rem]" data-id="element-117" data-mp="399thndbur8hm">
            Le sauvage,
            <br data-id="element-118" data-mp="30gq6jbooj7q5" />
            <span className="italic text-sage" data-id="element-119" data-mp="30g6m9obk478y">apprivoisé.</span>
          </motion.h1>
          <motion.p {...fade(0.2)} className="mt-8 max-w-md text-base leading-relaxed text-cream/75 lg:text-lg" data-id="element-120" data-mp="35aud3tu19dqp">
            Chatterie Pardus Dei — des chatons Bengal sélectionnés pour leur santé, leur tempérament équilibré et leur
            beauté sauvage.
          </motion.p>
          <motion.div {...fade(0.28)} className="mt-10 flex flex-wrap items-center gap-4" data-id="element-121" data-mp="2hjoytj3qqtii">
            <a href="#chatons" className="group inline-flex items-center gap-3 rounded-full bg-sage px-7 py-4 text-sm font-medium text-ink transition-colors duration-150 hover:bg-cream" data-id="element-122" data-mp="2ljgzl9mw7vdb">
              Voir les chatons disponibles
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" data-id="element-123" data-mp="ibowkga76es9" />
            </a>
            <a href="#chatterie" className="inline-flex items-center rounded-full border border-cream/25 px-7 py-4 text-sm text-cream transition-colors duration-150 hover:border-cream/60" data-id="element-124" data-mp="deq8aed7t21z">
              Découvrir la chatterie
            </a>
          </motion.div>
        </div>

        <div className="mt-20 hidden items-end justify-between border-t border-cream/15 pt-6 text-sm text-stone md:flex" data-id="element-125" data-mp="114svag29vhtq">
          <span data-id="element-126" data-mp="3lsp1x9cpsbcb">À 1h30 de Lyon</span>
          <span data-id="element-127" data-mp="3lu07neppzt62">Chatons livrés en France & à l'international</span>
          <span data-id="element-128" data-mp="3hrlkwjixk99i">Départ à 12 semaines</span>
        </div>
      </div>
    </section>;
}